import * as Entities from "@/resources/Entities";
import {
  filterCriteria as msoSupplierFilterCriteria,
  searchColumnHeaders as msoSupplierColumnHeaders,
} from "../MSOSupplier/inputs";

import {
  filterCriteria as stateCategoryTypeFilterCriteria,
  searchColumnHeaders as stateCategoryTypeColumnHeaders,
} from "../StateCategoryType/inputs";

import {
  filterCriteria as stateUnitOfMeasureFilterCriteria,
  searchColumnHeaders as stateUnitOfMeasureColumnHeaders,
} from "../StateUnitOfMeasure/inputs";

import {
  searchColumnHeaders as strainColumnHeaders,
  filterCriteria as strainFilterCriteria,
} from "../Strain/inputs";

import {
  filterCriteria as brandFilterCriteria,
  searchColumnHeaders as brandColumnHeaders,
} from "../Brand/inputs";

import {
  filterCriteria as msoGroupFilterCriteria,
  searchColumnHeaders as msoGroupColumnHeaders,
} from "../MSOGroup/inputs";
import productExtraInfo from "@/constants/productExtraInfo";

// Page Header
export const pageHeader = {
  title: "MSO Product",
  isEditorView: true,
  cancelPath: "msoProducts",
  addPath: "msoProductEditor",
  buttonLabel: "Save",
};

// Page Header
export const listPageHeader = {
  title: "MSO Products",
  isEditorView: false,
  buttonLabel: "New",
  routerPath: "msoProductEditor",
};

export const filterCriteria = [
  {
    label: "Name",
    code: "name",
    field: { type: "input", label: "name" },
    isPartial: true,
  },
  {
    label: "Brand",
    code: "externalFields.brand.name",
    field: { type: "input", label: "Brand" },
    isPartial: true,
  },
  {
    label: "Group Name",
    code: "externalFields.msoGroup.name",
    field: { type: "input", label: "Group Name" },
    isPartial: true,
  },
  {
    label: "Online Store Name",
    code: "onlineStoreName",
    field: { type: "input", label: "Online Store Name" },
    isPartial: true,
  },
  {
    label: "State Category",
    code: "externalFields.stateCategoryType.name",
    field: { type: "input", label: "State Category" },
    isPartial: true,
  },
  {
    label: "Supplier",
    code: "externalFields.msoSupplier.name",
    field: { type: "input", label: "Supplier" },
    isPartial: true,
  },
  {
    label: "MSO Product Id",
    code: "_id",
    field: { type: "input", label: "MSO Product Id" },
  },
];

export const columnHeaders = [
  {
    id: "open",
    type: "button",
    action: "navigateToEntity",
    iconName: "folder-open",
    ariaLabel: "Open",
  },
  {
    title: "Active",
    id: "isActive",
    type: "checkbox",
  },
  {
    title: "MSO Supplier",
    id: "externalFields.msoSupplier.name",
  },
  {
    title: "MSO Group",
    id: "externalFields.msoGroup.name",
    size: "large",
  },
  {
    title: "Grams",
    id: "cannabisGramsUnit",
  },
  {
    title: "Name",
    id: "name",
    size: "large",
  },
  {
    title: "Brand Name",
    id: "brand.name",
    size: "large",
  },
  {
    title: "State Category",
    id: "externalFields.stateCategoryType.name",
    size: "large",
  },
  {
    title: "Online Store Name",
    id: "onlineStoreName",
    size: "large",
  },
  {
    title: "Id",
    id: "_id",
  },
];

export const searchColumnHeaders = [
  {
    id: "select",
    type: "button",
    action: "selectItem",
    position: "sticky",
    iconName: "hand-pointer",
    ariaLabel: "Open",
  },
  {
    title: "Active",
    id: "isActive",
    type: "checkbox",
  },
  {
    title: "Archived",
    id: "isArchived",
    type: "checkbox",
  },
  {
    title: "Name",
    id: "name",
  },
  {
    title: "MSO Supplier",
    id: "externalFields.msoSupplier.name",
  },
  {
    title: "MSO Group",
    id: "externalFields.msoGroup.name",
  },
  {
    title: "Grams",
    id: "cannabisGramsUnit",
  },
  {
    title: "Brand Name",
    id: "brandName",
  },
  {
    title: "State Category",
    id: "externalFields.stateCategoryType.name",
  },
  {
    title: "Online Store Name",
    id: "onlineStoreName",
  },
  {
    title: "Id",
    id: "_id",
  },
];

export const msoProductInfoInputs = [
  {
    id: "name",
    placeholder: "Product Name",
    type: "input",
    title: "Product Name",
  },
  {
    id: "cannabisGramsUnit",
    placeholder: "Cannabis Grams/Unit",
    type: "number",
    precision: 3,
    title: "Cannabis Grams/Unit",
  },
  {
    id: "msoSupplier",
    placeholder: "Select MSO Supplier",
    type: "search",
    title: "MSO Supplier",
    label: "name",
    entity: Entities.MSOSUPPLIER,
    columnHeaders: msoSupplierColumnHeaders,
    filterCriteria: msoSupplierFilterCriteria,
    filter: {
      isActive: true,
      $and: [{ isArchived: false }, { isDeleted: false }],
    },
  },
  {
    id: "msoGroup",
    placeholder: "Select MSO Group",
    type: "search",
    title: "MSO Group",
    label: "name",
    entity: Entities.MSOGROUP,
    columnHeaders: msoGroupColumnHeaders,
    filterCriteria: msoGroupFilterCriteria,
    filter: {
      isActive: true,
      $and: [{ isArchived: false }, { isDeleted: false }],
    },
  },
  {
    id: "brand",
    placeholder: "Select Brand",
    type: "search",
    title: "Brand",
    label: "name",
    entity: Entities.BRAND,
    isClearable: true,
    columnHeaders: brandColumnHeaders,
    filterCriteria: brandFilterCriteria,
    filter: {
      $and: [{ isArchived: false }],
    },
  },
  {
    id: "strain",
    placeholder: "Strain",
    type: "search",
    title: "Strain",
    label: "name",
    entity: Entities.STRAIN,
    columnHeaders: strainColumnHeaders,
    filterCriteria: strainFilterCriteria,
    isClearable: true,
    filter: {
      isArchived: false,
    },
  },
  {
    id: "onlineStoreName",
    placeholder: "Online Store Name",
    type: "input",
    title: "Online Store Name",
  },
  {
    title: "State Category Information",
    id: "stateCategoryType",
    type: "search",
    isClearable: true,
    entity: Entities.STATECATEGORYTYPE,
    columnHeaders: stateCategoryTypeColumnHeaders,
    filterCriteria: stateCategoryTypeFilterCriteria,
    filter: {
      isArchived: false,
      isDeleted: false,
    },
    fieldsToDisplay: [
      { label: "Category Type", id: "productCategoryType" },
      { label: "Category Name", id: "name" },
      { label: "Quantity Type", id: "quantityType" },
    ],
  },
  {
    title: "State Unit of Measure",
    id: "stateUnitOfMeasure",
    type: "search",
    isClearable: true,
    entity: Entities.STATEUNITOFMEASURE,
    columnHeaders: stateUnitOfMeasureColumnHeaders,
    filterCriteria: stateUnitOfMeasureFilterCriteria,
    filter: {
      isArchived: false,
      isDeleted: false,
    },
    fieldsToDisplay: [
      { label: "UoM Name", id: "name" },
      { label: "UoM Abbreviation", id: "abbreviation" },
      { label: "Quantity Type", id: "quantityType" },
    ],
  },
  {
    id: "isActive",
    label: "Is Active",
    type: "checkBox",
    title: "Is Active",
  },
  {
    id: "onlineStoreDescription",
    placeholder: "Online Store Description",
    type: "textarea",
    title: "Online Store Description",
    class: "grid-row-two-column",
  },
  {
    id: "imageNormal",
    placeholder: "Upload Image",
    type: "fileUploader",
    title: "Product Image",
  },
  {
    id: "imageNormal.secure_url",
    type: "input",
    placeholder: "Image URL",
    title: "Image URL",
  },
  {
    id: "notes",
    placeholder: "Notes",
    type: "textarea",
    title: "Notes",
    class: "grid-row-two-column",
  },
];

export const extraInfoInputs = [
  {
    id: "name",
    placeholder: "Name",
    type: "select",
    title: "Name",
    options: productExtraInfo,
  },
  {
    id: "value",
    type: "input",
    title: "Value",
    placeholder: "Value",
  },
];

export const defaultSelectedMsoProduct = {
  _id: "NEW",
  batchId: "",
  name: "",
  brand: undefined,
  isDeleted: false,
  isArchived: false,
  isActive: true,
  notes: "",
  cannabisGramsUnit: "",
  onlineStoreDescription: "",
  onlineStoreName: "",
  brandName: "",
  verifiedBy: {},
  createdBy: {},
  updatedBy: {},
  imageNormal: {},
  imageThumbnail: {},
  msoGroup: undefined,
  msoSupplier: undefined,
  stateCategoryType: undefined,

  //must code by State
  stateUnitOfMeasure: '674752740c5ab05ad99def30',

  strain: undefined,
  flavors: [],
  effects: [],
  terpenes: [],
  tags: [],
};
